<!-- Mobile Component -->
<app-part-detail-mobile *ngIf="isMobile" [id]="id" [activeTabIndex]="activeTabIndex"
  (goBackView)="goBackView.emit($event)">
</app-part-detail-mobile>

<!-- Desktop Component -->
<div *ngIf="!isMobile" class="product-detail-container">
  <!-- Header -->
  <div class="flex items-center cursor-pointer" (click)="goBack()">
    <svg-icon [iconName]="'new/back-left.svg'" class="mr-1 ml-[-6px]"></svg-icon>返回
  </div>

  <!-- Main Content -->
  <nz-spin [nzSpinning]="isDetailLoading" nzTip="加载中...">
    <div class="main-content">
      <div class="product-section">
        <!-- Left Column - Product Images -->
        <div class="image-section">
          <nz-image-group style="display: block;">
            <div class="main-image">
              <img [src]="getImage(imageList)" (click)="previewCurrentImage()" class="cursor-zoom-in" />
            </div>
            <span class="image-desc">*{{ getImageDescription() }}</span>
            <!-- Thumbnail Navigation -->
            <div class="img-wrap-list" *ngIf="imageList.length>0">
              <ul class="img-container flex" [ngStyle]="{'left.px': -currentIndex * itemWidth}">
                <li *ngFor="let item of imageList; let i = index" [class.active]="i === currentImageIndex"><img
                    nz-image [nzSrc]="getSingleImage(item)" (click)="selectImage(i)" class="cursor-pointer" /></li>
              </ul>

            </div>
          </nz-image-group>

          <div class="mt-5 flex justify-between items-center" *ngIf="imageList.length>0">
            <span class="text-[12px]">{{ currentImageIndex + 1 }} / {{ imageList.length }}</span>
            <div>
              <button nz-button nzType="text" nzSize="small" (click)="scrollLeft()">
                <i nz-icon nzType="left"></i>
              </button>
              <button nz-button nzType="text" nzSize="small" (click)="scrollRight()">
                <i nz-icon nzType="right"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Right Column - Product Details -->
        <div class="details-section">
          <nz-card [nzBordered]="false" [nzBodyStyle]="{ padding: '0px' }">
            <div class="product-code">
              <span class="code">{{ productData?.partNo }}</span>
              <button nz-button nzType="text" nzSize="small" (click)="copyProductCode()">
                <i nz-icon nzType="copy" style="color: #007BC0;"></i>
              </button>
            </div>

            <h2 class="product-name">{{ productData?.partName }}</h2>

            <ul class="specifications">
              <li>
                <span class="bullet"></span>
                <span>替代前序料号:</span>
                <span class="cursor-pointer"
                  *ngFor="let replaces of partVOList[0]?.previousPartList;let last = last">{{replaces.partNo}}{{
                  !last ? ' / ' : '' }}</span>
                <button *ngIf="partVOList[0]?.previousPartList?.length > 0" nz-button nzType="text" nzSize="small"
                  (click)="copyPartCode(partVOList[0]?.previousPartList)">
                  <i nz-icon nzType="copy" style="color: #007BC0;"></i>
                </button>
              </li>
              <li>
                <span class="bullet"></span>
                <span>替代后序料号:</span>
                <span class="cursor-pointer"
                  *ngFor="let replaces of partVOList[0]?.successorPartList;let last = last">{{replaces.partNo}}{{
                  !last ? ' / ' : '' }}</span>
                <button *ngIf="partVOList[0]?.successorPartList?.length > 0" nz-button nzType="text" nzSize="small"
                  (click)="copyPartCode(partVOList[0]?.successorPartList)">
                  <i nz-icon nzType="copy" style="color: #007BC0;"></i>
                </button>
              </li>
            </ul>

            <!-- <div class="font-bold pb-4 border-b border-solid border-[#000] mt-12">原厂信息</div> -->

            <!-- <div class="flex justify-between border-b border-solid border-[#E0E2E5] py-4"
            *ngFor="let oemNumber of productData?.oemNumbers;">
            <span> {{oemNumber?.mfrName}} </span>
            <span>{{oemNumber?.articleNumber}}</span>
          </div> -->

            <!-- <div class="product-form">
            <div class="form mt-8">
              <div class="flex items-center mt-8">
                <div class="form-text">{{'ADD_QTY' | translate }}</div>
                <quantity-input class="form-qty" mode="list" [(quantity)]="productData.quantity"
                  [moq]="productData.minumQty" (quantityBlur)="quantityBlur($event)"
                  (quantityChange)="quantityChange($event)"></quantity-input>
                <span class="ml-4 text-grey700">{{'MOQ' | translate}}:{{productData.minumQty}}</span>
              </div>
              <div class="flex items-center mt-8">
                <div class="form-text">{{'EXPECT_DATE' | translate }}</div>
                <nz-date-picker *ngIf="productData?.quantity" [nzAllowClear]="false" [nzSuffixIcon]="suffixDate"
                  [(ngModel)]="productData.expectedDate" [nzPlaceHolder]="'ADD_DATE'|translate"
                  class="form-date bosch-date-picker" nzFormat="yyyy-MM-dd" [nzShowToday]="false"
                  [nzRenderExtraFooter]="footerRender" [nzDisabledDate]="disabledDate"></nz-date-picker>
                <ng-container *nzSuffix><i class="beforeIcon"></i></ng-container>
                <ng-template #footerRender>
                  <div class="flex-center"><a (click)="chooseDate(productData)">{{'ONE_WEEK_LATER' | translate }}</a>
                  </div>
                </ng-template>
                <ng-template #suffixDate>
                  <svg-icon [isUrl]="false" [iconName]="'date.svg'" [size]="20"
                    class="color-grey"></svg-icon></ng-template>
              </div>
              <div class="flex mt-8"
                *ngIf="productData?.stockQty !== null && productData?.stockQty !== undefined && isLogin">
                <div class="form-text">{{'STOCK' | translate }}</div>
                <svg-icon
                  [iconName]="productData?.stockQty ===0?'new/red.svg':(productData?.quantity!<=productData?.stockQty! ?'new/green.svg':'new/yellow.svg')"></svg-icon>
              </div>
              <div class="primary-mid-btn add-cart mt-14" [ngClass]="{'disabled':!isLogin || userData?.queryUserPageInfoResDTO?.status!==2}">
                  <svg-icon [isUrl]="false" [iconName]="'cart.svg'" class="mr6" [size]="20"></svg-icon>
                  <span>{{'ADD_TO_CART' | translate }}</span>
                </div>
            </div>
          </div> -->
          </nz-card>
        </div>
      </div>

      <!-- Tabs Section -->
      <div class="tabs-section mt-[100px]">
        <nz-tabset [nzSelectedIndex]="0">
          <nz-tab nzTitle="技术参数">
            <nz-card [nzBordered]="false" [nzBodyStyle]="{ padding: '0px' }">
              <nz-row [nzGutter]="50">
                <nz-col [nzSpan]="6" *ngFor="let item of processData(productData)">
                  <!-- <div>{{criteria.featureNameCn}}</div>
                    <div>{{criteria.featureValueString}}</div> -->
                  <span *ngIf="item.featureValueString; else noFeatureValueString">
                    <span class="oe-code"
                      *ngIf="(productData?.category1Name?.includes('雨刮')) && (item.featureNameCn === '长度 1（英寸）'|| item.featureNameCn === '长度 2（英寸）'||item.featureNameCn === '雨刮1长度' || item.featureNameCn === '雨刮2长度(仅套装)'||item.featureNameCn === '长度 1' || item.featureNameCn === '长度 2'); else noFeatureName">
                      <span class="name-value">
                        <div class="flex justify-between my-3 pb-2 border-b border-solid border-[#E0E2E5]">
                          <span>{{editFeatureNameCn(item.featureNameCn)}}:</span>
                          <span>{{Math.round(parseFloat(item.featureValue)) }}</span>
                        </div>
                      </span>
                    </span>
                    <ng-template class="oe-code" #noFeatureName>
                      <span class="name-value">
                        <div class="flex justify-between my-3 pb-2 border-b border-solid border-[#E0E2E5]">
                          <span>{{ item.featureNameCn}}:</span>
                          <span>{{item.featureValueString }}</span>
                        </div>
                      </span>
                    </ng-template>
                  </span>
                  <ng-template #noFeatureValueString>
                    <span class="oe-code"
                      *ngIf="(productData?.category1Name?.includes('雨刮')) && (item.featureNameCn === '长度 1（英寸）'|| item.featureNameCn === '长度 2（英寸）'||item.featureNameCn === '雨刮1长度' || item.featureNameCn === '雨刮2长度(仅套装)'||item.featureNameCn === '长度 1' || item.featureNameCn === '长度 2'); else noFeatureName2">
                      <span class="name-value">
                        <div class="flex justify-between my-3 pb-2 border-b border-solid border-[#E0E2E5]">
                          <span>{{editFeatureNameCn(item.featureNameCn)}}:</span>
                          <span>{{Math.round(parseFloat(item.featureValue)) }}</span>
                        </div>
                      </span>
                    </span>
                    <ng-template class="oe-code" #noFeatureName2>
                      <div class="flex justify-between my-3 pb-2 border-b border-solid border-[#E0E2E5]">
                        <span>{{ item.featureNameCn}}:</span>
                        <span>{{item.featureValue + (item.featureUnit !== null ? item.featureUnit:'') }}</span>
                      </div>
                    </ng-template>
                  </ng-template>
                </nz-col>
              </nz-row>
            </nz-card>
          </nz-tab>

          <nz-tab nzTitle="适配车型">
            <nz-card [nzBordered]="false" [nzBodyStyle]="{ padding: '0px' }">
              <div class="tab-header">
                <h3>适配车型</h3>
                <div class="tab-actions">
                  <button nz-button *ngIf="isReportErrorVisible" (click)="showErrorReportModal()" class="default-small-btn">匹配报错</button>
                  <button nz-button nzType="primary" (click)="showAllVehiclesModal()"
                    class="primary-small-btn">查看所有匹配车型</button>
                </div>
              </div>

              <nz-table #compatibleTable [nzData]="matchedCars.slice(0, 5)" [nzPageSize]="10" [nzShowPagination]="false"
                class="result-table" [nzLoading]="isMatchedTableLoading" [nzWidthConfig]="widthConfig">
                <thead>
                  <tr>
                    <th *ngFor="let col of compatibleVehiclesColumns">{{ col.title }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let vehicle of compatibleTable.data">
                    <td>{{ vehicle.carBrandName }}</td>
                    <td>{{ vehicle.modelClass }}</td>
                    <td>{{ vehicle.carModelName }}</td>
                    <td>{{ vehicle.displacement }}</td>
                    <td>{{ vehicle.modelYear }}</td>
                    <td>{{ vehicle.carName }}</td>
                    <td>{{ vehicle.engineCode }}</td>
                    <td>
                      <div *ngIf="!isFromAllMatchedCars">
                        <div *ngFor="let appDes of partVOList[0].partDTO.appDesList">
                          <div>{{ appDes }}</div>
                        </div>
                      </div>
                      <div *ngIf="isFromAllMatchedCars">
                        <div *ngFor="let appDes of vehicle.appDesList">
                          <div>{{ appDes }}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <a *ngIf="hasVideoUrl(vehicle.categoryName,vehicle.remarkExternal)"
                        (click)="openVideoModal(vehicle.categoryName,vehicle.remarkExternal)"
                        style="cursor:pointer; color:#1890ff;">
                        {{ getRemarks(vehicle.remarkExternal, vehicle.categoryName) }}
                        <i nz-icon nzType="video-camera" nzTheme="outline"></i>
                      </a>
                      <span *ngIf="!isVideoModal(vehicle.remarkExternal)">{{vehicle.remarkExternal}}</span>
                    </td>
                  </tr>
                </tbody>
              </nz-table>
            </nz-card>
          </nz-tab>

          <nz-tab nzTitle="原厂信息">
            <div class="border-b border-solid border-[#E0E2E5] py-2"
              *ngFor="let oemNumber of productData?.partOriginFactoryList?.slice(0,4)">
              <div class="flex justify-between">
                <span>{{ oemNumber?.factoryBrandCn }}</span>
              </div>
              <div class="grid grid-cols-6 gap-x-2 pt-1">
                <span *ngFor="let num of oemNumber?.factoryNames">
                  {{ num }}
                </span>
              </div>
            </div>
          </nz-tab>

          <nz-tab nzTitle="安装限制">
          </nz-tab>

          <nz-tab nzTitle="下载中心">
          </nz-tab>
        </nz-tabset>
      </div>
    </div>
  </nz-spin>
  <!-- Error Report Modal -->
  <nz-modal [(nzVisible)]="isErrorReportVisible" nzTitle="匹配报错" [nzWidth]="800" (nzOnCancel)="handleErrorReportCancel()"
    [nzFooter]="errorReportFooter">
    <ng-container *nzModalContent>
      <form nz-form [formGroup]="errorReportForm" class="mt-8 search-form-item">
        <nz-form-item>
          <nz-form-label [nzSpan]="4" [nzRequired]="true">联系方式</nz-form-label>
          <nz-form-control [nzSpan]="18" nzErrorTip="请输入联系方式">
            <input nz-input formControlName="contactInfo" placeholder="请输入联系方式" class="bosch_input" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="4" [nzRequired]="true">请求主题</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-select formControlName="subjectType" class="bosch-select">
              <nz-option nzValue="01" nzLabel="匹配报错"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="4" [nzRequired]="true">您的问题</nz-form-label>
          <nz-form-control [nzSpan]="18" nzErrorTip="请输入问题描述（最多500字）">
            <textarea nz-input formControlName="content" [nzRows]="4" class="bosch_textarea"></textarea>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="4">报错车型</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <!-- <input nz-input formControlName="carIds" placeholder="报错车型" class="bosch_input" /> -->
            <nz-select nzMode="multiple" nzAllowClear nzPlaceHolder="请选择报错车型" formControlName="carIds">
              <nz-option *ngFor="let item of carIdOptions" [nzLabel]="item" [nzValue]="item">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="4"> 备注</nz-form-label>
          <nz-form-control [nzSpan]="18" nzErrorTip="请输入备注（最多500字）">
            <textarea nz-input formControlName="remark" placeholder="请输入备注" [nzRows]="3"
              class="bosch_textarea"></textarea>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="4">添加图片</nz-form-label>
          <nz-form-control [nzSpan]="18">
            <nz-upload class="w-[150px] h-[150px]" [nzBeforeUpload]="beforeUpload" [nzFileList]="fileList"
              [nzRemove]="removeFile" nzListType="picture" [nzLimit]="1">
              <div class="w-[150px] h-[150px] border border-dashed border-[#d9d9d9] flex-center flex-col"
                *ngIf="fileList.length < 1">
                <i nz-icon nzType="inbox" class="text-[#d9d9d9] text-[24px]"></i>
                <p class="!mt-4">点击上传图片</p>
              </div>
            </nz-upload>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="4"></nz-form-label>
          <nz-form-control>
            <label class="error-report-checkbox" nz-checkbox formControlName="agreeToPolicy">
              我已阅读并同意相关的 <li class="privacy-link" (click)="handleViewPrivacy('/myAccount/data-protection-policy', 1)">隐私条款</li>
            </label>
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>

    <ng-template #errorReportFooter>
      <div class="flex justify-center">
        <button nz-button (click)="handleErrorReportCancel()" class="default-small-btn">取消</button>
        <button nz-button nzType="primary" (click)="handleErrorReportSubmit()"
          class="primary-small-btn">
          提交
        </button>
      </div>

    </ng-template>
  </nz-modal>

  <!-- All Vehicles Modal -->
  <nz-modal [(nzVisible)]="isAllVehiclesVisible" [nzTitle]="productData?.partNo + '所有适配车型'" [nzWidth]="1200"
    (nzOnCancel)="handleAllVehiclesCancel()" (nzOnOk)="handleAllVehiclesCancel()">
    <ng-container *nzModalContent>
      <div>
        <p class="mt-4">品牌、车系、型号支持拼音首字母搜索</p>
        <div class="search-filters">
          <div class="filter-group">
            <div class="filter-item">
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="品牌" [(ngModel)]="selectedBrand"
                [nzFilterOption]="brandFilterOption" (ngModelChange)="onSelectBrandChange($event)">
                <nz-option *ngFor="let brand of allBrands" [nzLabel]="brand.brandName" [nzValue]="brand"></nz-option>
              </nz-select>
            </div>

            <div class="filter-item">
              <nz-select [(ngModel)]="selectedSeries" nzAllowClear nzPlaceHolder="车系" nzShowSearch
                [nzFilterOption]="seriesFilterOption" (ngModelChange)="onSelectSeriesChange($event)">
                <nz-option-group *ngFor="let group of allFilteredSeries" [nzLabel]="group.manufacturer">
                  <nz-option *ngFor="let item of group.modelClassList" [nzValue]="item"
                    [nzLabel]="item.modelClass"></nz-option>
                </nz-option-group>
              </nz-select>
            </div>

            <div class="filter-item">
              <nz-select nzShowSearch nzAllowClear nzPlaceHolder="型号" [(ngModel)]="selectedModel"
                [nzFilterOption]="modelFilterOption" (ngModelChange)="onSelectModelChange($event)">
                <nz-option *ngFor="let model of allFilteredModels" [nzLabel]="model.modelName"
                  [nzValue]="model"></nz-option>
              </nz-select>
            </div>
          </div>
          <div class="filter-group">
            <div class="filter-item">
              <nz-select nzMode="multiple" nzShowSearch nzAllowClear nzPlaceHolder="排量"
                [(ngModel)]="selectedDisplacement" (ngModelChange)="onSelectDisplacementChange($event)">
                <nz-option *ngFor="let disp of allFilteredDisplacements" [nzLabel]="disp" [nzValue]="disp"></nz-option>
              </nz-select>
            </div>

            <div class="filter-item">
              <nz-select nzMode="multiple" nzShowSearch nzAllowClear nzPlaceHolder="年款" [(ngModel)]="selectedYear">
                <nz-option *ngFor="let year of allFilteredYears" [nzLabel]="year" [nzValue]="year"></nz-option>
              </nz-select>
            </div>
            <img style="width: 30px; height: 30px; cursor: pointer;" src="assets/official-website/reload.svg"
              (click)="handleReloadFilter()">
            <button nz-button nzType="primary" style="width: 120px; height: 36px;"
              (click)="handleSearchCars()">搜索</button>
          </div>
        </div>
        <!-- Vehicles Table -->
        <!-- <nz-table #allVehiclesTable [nzData]="filteredVehicles" [nzLoading]="vehiclesLoading" [nzPageSize]="10"
          [nzScroll]="{ y: '600px' }" class="result-table mt-4"> -->

        <nz-table #allVehiclesTable [nzLoading]="isTableLoading" [nzData]="filteredVehicles" [nzPageSize]="pageSize"
          [nzShowPagination]="true" [nzFrontPagination]="false" [nzPageIndex]="pageIndex"
          (nzPageIndexChange)="onPageIndexChange($event)" nzShowSizeChanger [nzWidthConfig]="widthConfig"
          (nzPageSizeChange)="onPageSizeChange($event)" [nzShowTotal]="totalTemplate" [nzTotal]="pageInfo.totalCounts"
          [nzScroll]="{ y: '600px' }" class="result-table mt-4">
          <thead>
            <tr>
              <th *ngFor="let col of allVehiclesColumns">{{ col.title }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let vehicle of allVehiclesTable.data">
              <td>{{ vehicle.carBrandName }}</td>
              <td>{{ vehicle.modelClass }}</td>
              <td>{{ vehicle.carModelName }}</td>
              <td>{{ vehicle.displacement }}</td>
              <td>{{ vehicle.modelYear }}</td>
              <td>{{ vehicle.carName }}</td>
              <td>{{ vehicle.engineCode }}</td>
              <td>
                <div *ngFor="let appDes of vehicle.appDesList">
                  <div>{{ appDes }}</div>
                </div>
              </td>
              <td>
                <a *ngIf="hasVideoUrl(vehicle.categoryName,vehicle.remarkExternal)"
                  (click)="openVideoModal(vehicle.categoryName,vehicle.remarkExternal)"
                  style="cursor:pointer; color:#1890ff;">
                  {{ getRemarks(vehicle.remarkExternal, vehicle.categoryName) }}
                  <i nz-icon nzType="video-camera" nzTheme="outline"></i>
                </a>
                <span *ngIf="!isVideoModal(vehicle.remarkExternal)">{{vehicle.remarkExternal}}</span>
              </td>
            </tr>
          </tbody>
        </nz-table>
        <ng-template #totalTemplate let-total>
          <span style="font-size: 16px; margin-right: 10px;">共{{pageInfo.totalCounts}}条</span>
        </ng-template>
      </div>
    </ng-container>
  </nz-modal>
</div>
<!-- End Desktop Component -->
